import { render } from "./GeneralTermSelect.vue?vue&type=template&id=66e233aa"
import script from "./GeneralTermSelect.vue?vue&type=script&lang=js"
export * from "./GeneralTermSelect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__